<template>
  <div>
    <div class="panel-group">
      <div
        class="card-panel"
        @click="handleSetLineChartData('memberComplaint')"
        style="margin-left: 0"
      >
        <div class="card-panel-description">
          <div class="card-panel-text">空号投诉</div>
          <count-to
            :start-val="0"
            :end-val="data.complaintPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
      <div class="card-panel" @click="handleSetLineChartData('memberJubao')">
        <div class="card-panel-description">
          <div class="card-panel-text">匿名举报</div>
          <count-to
            :start-val="0"
            :end-val="data.jubaoPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
      <div
        class="card-panel"
        @click="handleSetLineChartData('memberNewAccountReview')"
      >
        <div class="card-panel-description">
          <div class="card-panel-text">新微信号审核</div>
          <count-to
            :start-val="0"
            :end-val="data.newAccountReviewPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
      <div
        class="card-panel"
        @click="handleSetLineChartData('memberWithdrawRecord')"
      >
        <div class="card-panel-description">
          <div class="card-panel-text">提现申请</div>
          <count-to
            :start-val="0"
            :end-val="data.withdrawRecordPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>


    
    </div>
    <div class="panel-group">
       <div
        class="card-panel"
        @click="handleSetLineChartData('avatar')"
        style="margin-left: 0"
      >
        <div class="card-panel-description">
          <div class="card-panel-text">新男头像审核</div>
          <count-to
            :start-val="0"
            :end-val="data.boyAvatarPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
      <div class="card-panel" @click="handleSetLineChartData('memberIndexVideoAuth')">
        <div class="card-panel-description">
          <div class="card-panel-text">右上角视频</div>
          <count-to
            :start-val="0"
            :end-val="data.rightVideoPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
      <div
        class="card-panel"
        @click="handleSetLineChartData('dynamicContent')"
      >
        <div class="card-panel-description">
          <div class="card-panel-text">新动态审核</div>
          <count-to
            :start-val="0"
            :end-val="data.dynamicPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
      <div
        class="card-panel"
        @click="handleSetLineChartData('memberDynamicComment')"
      >
        <div class="card-panel-description">
          <div class="card-panel-text">动态评论</div>
          <count-to
            :start-val="0"
            :end-val="data.dynamicCommentPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
    </div>



  <div class="panel-group">
   <div class="card-panel" @click="handleSetLineChartData3('memberHuodong')" style="margin-left:0">
        <div class="card-panel-description">
          <div class="card-panel-text">新活动审核</div>
          <count-to
            :start-val="0"
            :end-val="data.huodongPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
    </div>


      <div class="panel-group">
     <div
        class="card-panel"
        @click="handleSetLineChartData2('MemberAuthCarVideo')"
        style="margin-left:0"
      >
        <div class="card-panel-description">
          <div class="card-panel-text">座驾认证</div>
          <count-to
            :start-val="0"
            :end-val="data.carVideoPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
      <div
        class="card-panel"
        @click="handleSetLineChartData2('memberAuthDavi')"
      >
        <div class="card-panel-description">
          <div class="card-panel-text">大V认证</div>
          <count-to
            :start-val="0"
            :end-val="data.daViPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
      <div
        class="card-panel"
        @click="handleSetLineChartData2('memberAuthEducation')"
      >
        <div class="card-panel-description">
          <div class="card-panel-text">学历认证</div>
          <count-to
            :start-val="0"
            :end-val="data.educationPending || 0"
            class="card-panel-num"
          />
        </div>
      </div>
    </div>


  

  </div>
</template>

<script>
import CountTo from "vue-count-to";

export default {
  components: {
    CountTo,
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {
          carVideoPending: 0,
          complaintPending: 0,
          daViPending: 0,
          educationPending: 0,
          jubaoPending: 0,
          newWechatReviewPending: 0,
          withdrawRecordPending: 0,
        };
      },
    },
  },
  methods: {
    handleSetLineChartData(type) {
      this.$emit("handleSetLineChartData", type);
    },
    handleSetLineChartData2(type) {
      this.$emit("handleSetLineChartData2", type);
    },
    handleSetLineChartData3(type) {
      this.$emit("handleSetLineChartData3", type);
    },
  },
};
</script>

<style lang="scss" scoped>
.iconfont::before {
  margin: 0;
}

.panel-group {
  // margin-top: 18px;
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    // height: 90px;
    margin: 10px 5px;
    min-width: 200px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);
    display: flex;
    // justify-content: space-between;

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #f4516c;
        // background: #36a3f7;
      }

      .icon-money {
        background: #36a3f7;
      }

      .icon-shopping {
        background: #36a3f7;
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #f4516c;
    }

    .icon-money {
      color: #36a3f7;
    }

    .icon-shopping {
      color: #36a3f7;
    }

    .card-panel-icon-wrapper {
      .iconfont {
        font-size: 36px;
      }

      padding: 10px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-description {
      font-weight: bold;
      display: flex;
      justify-content: center;
      // flex-direction: column;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      padding: 10px;

      .card-panel-text {
        line-height: 18px;
        color: #999;
        font-size: 18px;
      }

      .card-panel-num {
        font-size: 20px;
        color: #ff6060;
      }
    }
  }
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;
  }
}
</style>
